 <template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import checkUpdate from '@/common/uploadVersion'
Vue.directive('numbers', { //定义只能输入数字且保留两位小数的指令
  inserted(el) {
    el.addEventListener('keypress',function(e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number'?e.charCode : e.keyCode
      let re = /[^\d]/
      if (re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  },
  bind(el, binding, vnode) {
    // 处理千分位展示
    const generatingThousandthPer = (num) => {
      return num
    }
    // 赋值
    const assignment = (event, value) => {
      vnode.context.$nextTick(() => {
        let result = generatingThousandthPer(value);
        event.target.value = result.replace(/^(\d\d)$/,"$1");
      })
    }
    // 处理最后一位非法字符
    const handlerIllegalStr = (str) => {
      while (!(/^[0-9]+/.test(str.charAt(str.length - 1)))) {
        str = str.substr(0, str.length - 1)
      }
      return str
    }

    el.addEventListener("input", (event) => {
      let inp = event.target.value = event.target.value.replace(/[^\d]/g, "")
      assignment(event, inp)
    })

    // element
    const input = $(el).find(".el-input__inner")
    if (input.length>1) {
      input[0].addEventListener("blur", (event) => {
        const val = event.target.value;
        if (!val || !/^[0-9]+/.test(val)) return;
        assignment(event, handlerIllegalStr(val.replace(/,/g, "")))
      })
    }
  }
})
Vue.directive('input-number', {
  bind(el, binding, vnode) {
    const target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener('keyup', e => {
      let val = e.target.value;
      // modifiers为修饰符对象，传入了float，则其float属性为true
      if (binding.modifiers.float) {
        // 清除"数字"和"."以及"-"以外的字符
        val = val.replace(/[^\-\d.]/g, '')
        // 只保留第一个“点”号, 清除多余的
        const idx = val.indexOf('.')
        if (!(idx === -1 || idx === val.length - 1)) {
          val = val.substr(0, idx) + '.' + val.substr(idx + 1).replace(/\./g, '')
        }
        // 只保留首位的负号, 清除多余的
        if (val.length > 1) {
          val = val.charAt(0) + val.substr(1).replace(/-/g, '')
        }
        // 将 '-.' 替换成 '-0.'
        val = val.replace(/^\./g, '0.').replace(/^\-\./, '-0.')
        if (typeof binding.value !== 'undefined') {
          // 期望保留的最大小数位数
          let pointKeep = 0
          if (typeof binding.value === 'string' || typeof binding.value === 'number') {
            pointKeep = parseInt(binding.value)
          } else if (typeof binding.value === 'object') {
            // 支持新的小数点保留位配置
            pointKeep = binding.value.decimal
          }
          if (!isNaN(pointKeep)) {
            if (!Number.isInteger(pointKeep) || pointKeep < 0) {
              pointKeep = 0
            }
            // 增加'-'号的支持
            const str = '^(\\-)*(\\d+)\\.(\\d\{' + pointKeep + '}).*$'
            const reg = new RegExp(str)
            if (pointKeep === 0) {
              // 不需要小数点
              val = val.replace(reg, '$1$2')
            } else {
              // 通过正则保留小数点后指定的位数
              val = val.replace(reg, '$1$2.$3')
            }
          }
        }
      } else {
        val = e.target.value.replace(/[^\-\d]/g, '').replace(/^(\-)*(\d*)$/, '$1$2')
      }
      if (val !== '' && typeof binding.value === 'object') {
        let { min, max } = binding.value
        min = parseFloat(min)
        max = parseFloat(max)
        if (!isNaN(min)) {
          if (min >= 0) {
            // 不能是负数
            val = val.replace('-', '')
          }
          if (parseFloat(val) < min) {
            val = min
          }
        }
        if (!isNaN(max)) {
          if (parseFloat(val) > max) {
            val = max
          }
        }
      }
      if(binding.modifiers.thousand) {
        val = val.toString().replace(/\d+/, function(n){ // 先提取整数部分
          return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
            return $1+",";
          });
        })
      }
      e.target.value = val;
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit('input', val)
      } else {
        vnode.elm.dispatchEvent(new CustomEvent('input', val))
      }
    })
  }
})
Vue.filter('statusToTxt',function(status){
  switch(status) {
    case 1:
      return '待提交';
    case 2:
      return '待审核';
    case 3:
      return '已通过';
    case 4:
      return '已撤回';
    case 5:
      return '已驳回';
  }
})
Vue.filter('dateToTxt', function(dateStr) {
  if(!dateStr) return '';
  let isDate = dateStr instanceof Date
  if(!isDate) {
    return dateStr.substring(0, 10);
  }
  let y = dateStr.getFullYear(),
      m = dateStr.getMonth() + 1,
      d = dateStr.getDate();
      m = m < 10? '0' + m : m;
      d = d < 10? '0' + d : d;
  return `${y}-${m}-${d}`
})
Vue.filter('str2date', function(str) {
  let h = Math.floor(str / 3600),
      m = Math.floor(str % 3600 / 60),
      s = str % 3600 % 60;
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  s = s < 10 ? '0' + s : s;
  return `${h}:${m}:${s}`
})
Vue.filter('str2date2', function(str) {
  if(str * 1 < 0) return '00:00'
  let h = Math.floor(str / 3600),
      m = Math.floor(str % 3600 / 60),
      s = str % 3600 % 60;
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  s = s < 10 ? '0' + s : s;
  if(h == '00') {
    return `${m}:${s}`
  }
  return `${h}:${m}:${s}`
})
Vue.filter('num2type',function(num){
  let qArrs = ['单选题', '多选题', '判断题'];
  return qArrs[num - 1];
})
Vue.filter('num2type2',function(num){
  let qArrs = ['单选', '多选', '判断'];
  return qArrs[num - 1];
})
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive:true,
    }
  },
  created(){
    process.env.NODE_ENV === 'production' && checkUpdate()
    sessionStorage.setItem('pageSize',20)
    sessionStorage.setItem('pageSize2',10)
    sessionStorage.setItem('fileUrl','../../');
    // sessionStorage.setItem('fileUrl','../../../');
  },
  methods:{
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue